<form #leadForm="ngForm" class="mt-0" (ngSubmit)="submitForm(leadForm.valid)">

    <p-accordion value="-1">
        <p-accordion-panel value="0">
            <p-accordion-header>Bio Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Prefix</label>
                        <p-select class="w-full profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['prefix']" name="prefix"
                            [options]="prefixOptions"></p-select>
                    </div>



                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">First Name</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['first_name']" name="first_name" required
                            pattern="^[a-zA-Z ]*$" #first_name="ngModel"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['first_name']}" />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['first_name']">Enter
                            First
                            Name</small>

                        <small class="text-red-500" *ngIf="first_name?.errors?.['pattern']">
                            Special characters are not allowed.
                        </small>

                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Last Name</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['last_name']" name="last_name" required
                            pattern="^[a-zA-Z ]*$" #last_name="ngModel"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['last_name'] }" />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['last_name']">Enter Last
                            Name</small>
                        <small class="text-red-500" *ngIf="last_name?.errors?.['pattern']">
                            Special characters are not allowed.
                        </small>
                    </div>

                    <div class="col-span-1">
                        <label class="block mb-2">Guardian Name</label>
                        <input pInputText class="w-full shadow-none profile-input"
                            [(ngModel)]="createFieldFormValue.guardian_name" name="guardian_name" />
                    </div>

                    <div class="col-span-1">
                        <label class="block mb-2">Guardian Contact</label>
                        <input pInputText class="w-full shadow-none profile-input"
                            [(ngModel)]="createFieldFormValue.guardian_contact" name="guardian_contact" type="number" />
                    </div>


                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Date of Birth</label>
                        <p-datepicker class="w-full  " appendTo="body" [inputStyle]="{
                                    'box-shadow':'none !important',
                                    'width': '100%',
                                    'border': 'none',
                                    'background-color': 'transparent',
                                    'border-radius': '10px',
                                }" [style]="{'box-shadow':'none !important',
                                    'width': '100%',
                                    'background-color': 'transparent',
                                    'border': 'none',
                                    'border-radius': '10px',
                                 }" [maxDate]="today" [(ngModel)]="createFieldFormValue['date_of_birth']"
                            name="date_of_birth" />
                        <div class="w-full profile-input h-[33px] -mt-[32px] z-50 rounded-[5px]">
                        </div>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Age</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['age']" name="age" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Gender</label>
                        <p-select class="w-full profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue['gender']" name="gender" [options]="genderOptions" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Nationality</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['nationality']" name="nationality" />
                    </div>

                </div>
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="1">
            <p-accordion-header>
                Academic , Department and Batch Details
            </p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">
                            Academic Year
                        </label>
                        <p-select class="w-full shadow-none profile-select" appendTo="body" [disabled]="true"
                            [(ngModel)]="createFieldFormValue.academic_year_id" name="academic_year" optionValue="id"
                            optionLabel="year_name" [options]="academicYearList" required
                            [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.academic_year_id}">
                        </p-select>

                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue.academic_year_id">
                            Select Academic Year
                        </small>
                    </div>

                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">
                            Student Department
                        </label>
                        <p-select class="w-full profile-select " appendTo="body" [disabled]="true"
                            [(ngModel)]="createFieldFormValue.department_id" name="department"
                            [options]="departmentList" optionLabel="name" required optionValue="dept_id"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['department_id']}"></p-select>

                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['department_id']">Select
                            Department</small>

                    </div>


                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">
                            Assigned Batch
                        </label>
                        <p-select class="w-full profile-select " appendTo="body" [disabled]="true"
                            [(ngModel)]="createFieldFormValue.batch_id" name="batch" [options]="batchList" required
                            optionLabel="batch_name" optionValue="id"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['batch_id']}"></p-select>

                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['batch_id']">Select
                            Batch</small>


                    </div>

                </div>
            </p-accordion-content>
        </p-accordion-panel>


        <p-accordion-panel value="2">
            <p-accordion-header>Admission Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue"> Admission Status</label>
                        <p-select class="w-full shadow-none profile-select" appendTo="body" [disabled]="true"
                            [(ngModel)]="createFieldFormValue.admission_status" name="admission_status"
                            [options]="admissionStatusList" required
                            [ngClass]="{
                                        'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue.admission_status}">
                        </p-select>

                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue.admission_status">
                            Select Status
                        </small>
                    </div> -->

                    <!-- <div class="col-span-1">
                        <label class="block mb-2 requiredValue">Admission Source</label>
                        <p-select class="w-full profile-select " appendTo="body"
                            [(ngModel)]="createFieldFormValue['admission_source']" name="admission_source"
                            [options]="leadSources" required
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_source']}"></p-select>

                        <small class="text-red-500"
                            *ngIf="isSubmitted && !createFieldFormValue['admission_source']">Select
                            Source</small>

                    </div> -->


                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">Admission Type</label>
                        <p-select class="w-full profile-select " appendTo="body"
                            [(ngModel)]="createFieldFormValue['admission_type']" name="admission_type"
                            [options]="admissionTypes" required [disabled]="true"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_type']}"></p-select>

                        <small class="text-red-500"
                            *ngIf="isSubmitted && !createFieldFormValue['admission_type']">Select
                            Type</small>

                    </div>

                    <!-- admission mode -->
                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">Admission Mode</label>
                        <p-select class="w-full profile-select " appendTo="body"
                            [(ngModel)]="createFieldFormValue['admission_mode']" name="admission_mode"
                            [options]="modeOfStudyOptions" required [disabled]="true"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_mode']}"></p-select>

                        <small class="text-red-500"
                            *ngIf="isSubmitted && !createFieldFormValue['admission_mode']">Select
                            Mode</small>

                    </div>

                </div>
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="3">
            <p-accordion-header>
                Assign To , Education and Course Details
            </p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="col-span-1">
                        <label class="block mb-2 ">Assigned To</label>
                        <p-select appendTo="body" class="w-full profile-select" [disabled]="true"
                            [(ngModel)]="createFieldFormValue['assigned_to']" name="assigned_to"
                            [options]="users"></p-select>
                    </div>

                    <div *ngIf="isFixedColumn && editType != 'leads' && editType != 'enrollment'" class="col-span-1">
                        <label class="block mb-2">Previous Education</label>
                        <input pInputText class="w-full shadow-none profile-input"
                            [(ngModel)]="createFieldFormValue.previous_education" name="previous_education"
                            type="text" />
                    </div>



                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">Selected Course</label>
                        <p-select class="w-full shadow-none profile-select" appendTo="body"
                            [(ngModel)]="createFieldFormValue.course_id" name="preferred_course" [options]="allCourses"
                            optionLabel="name" optionValue="course_id" required [disabled]="true"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue?.course_id}">
                        </p-select>

                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue?.course_id">
                            Select Preferred Course
                        </small>
                    </div>

                </div>

            </p-accordion-content>
        </p-accordion-panel>


        <p-accordion-panel value="4">
            <p-accordion-header>Contact Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Contact Email</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['email']" name="email" required
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['email']}" />
                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['email']">Enter
                            Contact
                            Email</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2 requiredValue">Contact Number</label>

                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['phone'] }"
                            [(ngModel)]="createFieldFormValue['phone']" name="phone" required />
                        <small class="text-red-500" *ngIf="isSubmitted && (!createFieldFormValue['phone']
                                )">Enter Contact Number</small>
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Alternate Number</label>

                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['alternate_phone']" name="alternate_phone" />
                    </div>

                </div>
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="10">
            <p-accordion-header>Guardian Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- guardian_contact guardian_name -->
                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Guardian Name</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['guardian_name']" name="guardian_name" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Guardian Contact</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['guardian_contact']" name="guardian_contact"
                            type="number" />
                    </div>

                </div>
            </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel value="5">
            <p-accordion-header>Demographic Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">


                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">City</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['city']" name="city" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">State</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['state']" name="state" />
                    </div>



                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Country</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['country']" name="country" />
                    </div>

                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Postal Code</label>
                        <input pInputText class="w-full profile-input" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['postal_code']" name="postal_code" />
                    </div>



                </div>
                <div class="grid grid-cols-1 mt-4">
                    <div class="col-span-1">
                        <label class="block mb-2">Address</label>
                        <textarea pTextarea class="w-full profile-input" rows="5" style="box-shadow: none !important;"
                            [(ngModel)]="createFieldFormValue['address']" name="address"></textarea>
                    </div>

                </div>
            </p-accordion-content>
        </p-accordion-panel>


        <p-accordion-panel value="6">
            <p-accordion-header>Fee Details and Scholarship Details</p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div class="col-span-1">
                        <label class="block mb-2 requiredValue">Fee Category</label>
                        <p-select class="w-full profile-select" appendTo="body" [placeholder]="'Select Fee Category'"
                            [(ngModel)]="createFieldFormValue.fee_group_id" name="payment_for" [disabled]="true"
                            [options]="feeCategoryList" optionLabel="group_name"
                            (ngModelChange)="onPaymentForChange($event)" optionValue="id" required
                            [ngClass]="{'ng-invalid ng-dirty':  isSubmitted && !createFieldFormValue?.fee_group_id}">
                        </p-select>

                        <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue?.fee_group_id">
                            Select Fee Category
                        </small>
                    </div>



                    <!-- scholarship_id  -->


                    <div *ngIf="isFixedColumn" class="col-span-1">
                        <label class="block mb-2">Scholarship</label>
                        <p-select class="w-full profile-select" appendTo="body" [placeholder]="'Select Scholarship'"
                            [(ngModel)]="createFieldFormValue.scholarship_id" name="scholarship_id" [disabled]="true"
                            [options]="scholarshipList" optionLabel="name" optionValue="scholarship_id">
                        </p-select>
                    </div>
                </div>


            </p-accordion-content>
        </p-accordion-panel>
        <!-- transport_category  transport_required scholarship_id hostel_required hostel_category -->


        <p-accordion-panel value="7">
            <p-accordion-header>
                Transport and Hostel Details
            </p-accordion-header>
            <p-accordion-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div class="col-span-1">
                        <label class="block mb-2 ">
                            Transport Category
                        </label>
                        <p-select class="w-full profile-select" appendTo="body"
                            [placeholder]="'Select Transport Category'" [disabled]="true"
                            [(ngModel)]="createFieldFormValue.transport_category" name="transport_category"
                            [options]="transportRouteList" optionLabel="route_name" optionValue="id"
                            [ngClass]="{'ng-invalid ng-dirty':  isSubmitted && !createFieldFormValue?.transport_category}">
                        </p-select>


                    </div>


                    <div class="col-span-1">
                        <label class="block mb-2 ">
                            Hostel Category
                        </label>
                        <p-select class="w-full profile-select" appendTo="body" [placeholder]="'Select Hostel Category'"
                            [(ngModel)]="createFieldFormValue.hostel_category" name="hostel_category"
                            [options]="hostelList" optionLabel="hostel_name" optionValue="id" [disabled]="true"
                            [ngClass]="{'ng-invalid ng-dirty':  isSubmitted && !createFieldFormValue?.hostel_category}">
                        </p-select>


                    </div>

                </div>


            </p-accordion-content>
        </p-accordion-panel>




        <!-- <p-accordion-panel value="6">
                                <p-accordion-header>
                                    Other Details
                                </p-accordion-header>
                                <p-accordion-content>
                                    <div *ngIf="fieldValues" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                                        <div *ngFor="let item of allLeadFeilds">
                                            <div class="col-span-1 w-full">
                                                <label class="block mb-2"
                                                    [ngClass]="{ 'requiredValue': item.required === 'true' }">
                                                    {{ item.label }}
                                                </label>

                                                <input *ngIf="item.type !== 'select' && item.type !== 'textarea'"
                                                    pInputText class="w-full profile-input"
                                                    [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                                    [required]="item.required === 'true' ? true : false"
                                                    [ngModelOptions]="{ standalone: false }" [ngClass]="{
                                    'ng-invalid ng-dirty': isSubmitted && item.required === 'true' && !fieldValues[item.field_name]
                                  }" />

                                                <textarea *ngIf="item.type === 'textarea'" pTextarea
                                                    style="box-shadow: none !important;" class="w-full"
                                                    [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                                    [required]="item.required === 'true' ? true : false"
                                                    [placeholder]="item.placeholder"></textarea>

                                                <p-select *ngIf="item.type === 'select'" class="w-full profile-select"
                                                    appendTo="body" [required]="item.required === 'true' ? true : false"
                                                    [(ngModel)]="fieldValues[item.field_name]" [name]="item.field_name"
                                                    [options]="item.data" [placeholder]="item.placeholder"></p-select>

                                                <small class="text-red-500"
                                                    *ngIf="isSubmitted && item.required === 'true' && !fieldValues[item.field_name]">
                                                    Enter {{ item.label }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel> -->





    </p-accordion>


    <div class="mt-4 w-full">
        <p-button type="submit" [label]="'Update'" class="w-full" [style]="{width: '100%'}" [icon]="'pi pi-pencil'"
            [disabled]="isLoading" [loading]="isLoading" class="p-button-primary w-full md:w-auto"></p-button>
    </div>

</form>